import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { gsap } from 'gsap';
import { Beheaded } from '../../Beheaded';
import { BGType } from './Background';
import { IDimOrientation, ResizeHelper } from '../../../core/utils/ResizeHelper';
import { AbstractSpine } from '../../../core/component/AbstractSpine';
import { TzantzaFlag } from './TzantzaFlag';

export class BackgroundOverlay extends PIXI.Container implements StageLayer {

    private readonly logoDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(.8, .8),
            position: new PIXI.Point(-190, 100.5),
        },
        portrait: {
            scale: new PIXI.Point(.8, .8),
            position: new PIXI.Point(80, -170),
        },
    };

    private readonly firefliesDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(-85, 300),
            rotation: 0,
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(390, -90),
            rotation: -90 * (Math.PI / 180),
        },
    };

    private readonly flagDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(.8, .8),
            position: new PIXI.Point(700, 500),
        },
        portrait: {
            scale: new PIXI.Point(.8, .8),
            position: new PIXI.Point(700, 500),
        },
    };


    private _backgroundTop: PIXI.spine.Spine;
    private _backgroundCouldronBottom: PIXI.spine.Spine;
    private _fireflies: AbstractSpine;
    protected _logo: PIXI.Sprite;

    protected flag: TzantzaFlag;

    constructor() {
        super();
        this.init();
    }

    protected init(): void {
        // base background
        this._backgroundTop = this.addChild(new PIXI.spine.Spine(Beheaded.assetLoader.getSpineAsset(BGType.OVERLAY)));
        this._backgroundTop.name = 'BackgroundTop';
        this._backgroundTop.state.setAnimation(0, 'lvl_0_loop', true);
        this._backgroundTop.position.set(360, 1150);

        // couldron texture
        this._backgroundCouldronBottom = this.addChild(
            new PIXI.spine.Spine(Beheaded.assetLoader.getSpineAsset(BGType.COULDRON_FRONT))
        );
        this._backgroundCouldronBottom.name = 'COULDRON';
        this._backgroundCouldronBottom.state.setAnimation(0, 'lvl_0_loop', true);
        this._backgroundCouldronBottom.position.set(375, 1150);

        //fireflies
        this._fireflies = this.addChild(new AbstractSpine('spine/tree_glow.json'));
        this._fireflies.name = 'fireflies';
        this._fireflies.getSpineTween('glow_loop', true);

        //logo
        this._logo = this.addChild(new PIXI.Sprite(Beheaded.assetLoader.getTextures('logo')[0]));
        this._logo.anchor.set(0.5, 0.5);


        this.flag = this.addChild(new TzantzaFlag());
        this.flag.angle = -19.5;

        this.onResize();
    }

    public upgradeBGOverlay(level: number, currentLvl: number = 0): gsap.core.Timeline {
        let tl: gsap.core.Timeline = new gsap.core.Timeline();
        let startAnimName: string = 'lvl_' + level + '_start';
        let loopAnimName: string = 'lvl_' + level + '_loop';
        let durr: number = Math.max(
            this._backgroundTop.spineData.findAnimation(startAnimName).duration,
            this._backgroundCouldronBottom.spineData.findAnimation(startAnimName).duration
        );
        tl.add(() => {
            this._backgroundTop.state.setAnimation(0, startAnimName, false);
            this._backgroundCouldronBottom.state.setAnimation(0, startAnimName, false);
        });
        tl.to(this, durr, {});
        tl.add(() => {
            this._backgroundTop.state.setAnimation(0, loopAnimName, true);
            this._backgroundCouldronBottom.state.setAnimation(0, loopAnimName, true);
        });
        return tl;
    }

    public flagShow(val:boolean){
        this.flag.showFlag(val);
    }

    public flagHit(val:number){
        this.flag.showAmm(val);
    }

    public flagHideHit(){
        this.flag.hideAll();
    }

    onResize(): void {
        const dim = ResizeHelper.calcDim(this.logoDim);
        this._logo.scale = dim.scale;
        this._logo.position = dim.position;
        this._logo.visible = !ResizeHelper.isIPadd;

        const dimFireflies = ResizeHelper.calcDim(this.firefliesDim);
        this._fireflies.scale = dimFireflies.scale;
        this._fireflies.position = dimFireflies.position;
        this._fireflies.rotation = dimFireflies.rotation!;

        const dimFlag = ResizeHelper.calcDim(this.flagDim);
        this.flag.position = dimFlag.position;
        this.flag.scale = dimFlag.scale;
    }
}
